import { Box, keyframes } from '@mui/material';

const animArtwork = () =>
  `${keyframes`
  0% {
    opacity: 0;
    transform: translateY(8px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`} 0.3s forwards`;

const animSign = () =>
  `${keyframes`
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-4px);
  }
  100% {
    transform: translateY(0;
  }
`} 1s ease-in-out infinite`;

const animCat = () =>
  `${keyframes`
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-4px);
  }
  100% {
    transform: translateY(0;
  }
`} 5s ease-in-out infinite`;

const animEyes = (x: number) =>
  `${keyframes`
  0% {
    transform: translateX(-${x}px);
  }
  50% {
    transform: translateX(${x}px);
  }
  100% {
    transform: translateX(-${x}px);
  }
`} 2s ease-in-out infinite`;

const ErrorArtwork: React.FC = () => {
  const eyeMoveX = 2;
  return (
    <Box
      sx={(theme) => ({
        width: 240,
        paddingBottom: theme.spacing(2),
        opacity: 0,
        animation: animArtwork(),
        svg: {
          width: '100%',
          height: 'auto',
          '#sign': {
            animation: animSign(),
          },
          '#cat': {
            animation: animCat(),
          },
          '#arm': {
            animation: animSign(),
          },
          '#eyes': {
            transform: `translateX(-${eyeMoveX}px)`,
            animation: animEyes(eyeMoveX),
          },
        },
      })}
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240" fill="none">
        {/* Hole */}
        <path
          fill="#00F1A3"
          stroke="#131313"
          strokeLinecap="square"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M100.621 229.627c52.478 0 95.02-9.479 95.02-21.172 0-11.693-42.542-21.172-95.02-21.172-52.478 0-95.02 9.479-95.02 21.172 0 11.693 42.541 21.172 95.02 21.172Z"
        />
        {/* Sign */}
        <g id="sign">
          <path
            fill="#fff"
            stroke="#131313"
            strokeMiterlimit={10}
            strokeWidth={2}
            d="m156.564 86.185-12.827 2.298 23.502 131.143 12.827-2.299-23.502-131.142Z"
          />
          <path
            fill="#fff"
            stroke="#131313"
            strokeWidth={2}
            d="m52.976 41.471 169.139-30.31 16.375 91.372-169.14 30.311-16.374-91.373Z"
          />
          <path
            fill="#131313"
            d="M145.609 93.745c-1.186.214-2.13.957-2.403 1.895l-.07.239-.431-1.43-2.207.394 2.161 12.059 2.351-.422-.96-5.355.187.25c.584.783 1.727 1.156 2.91.942 2.286-.41 3.674-2.562 3.237-5.004-.437-2.443-2.491-3.984-4.775-3.574v.006Zm.694 6.432a2.079 2.079 0 0 1-1.565-.346 2.109 2.109 0 0 1-.526-2.925c.318-.459.804-.77 1.348-.868a2.08 2.08 0 0 1 1.565.345 2.106 2.106 0 0 1 .526 2.926 2.08 2.08 0 0 1-1.348.868Zm9.146.66c1.746-.312 3.375-1.39 3.069-3.093-.214-1.199-1.176-1.899-2.937-2.125-.364-.052-.676-.092-.942-.131-1.155-.156-1.467-.196-1.528-.53-.058-.332.379-.638.85-.724.376-.067 1.03-.036 1.192.471l2.369-.425c-.352-1.513-1.978-2.32-3.989-1.96-2.097.377-3.002 1.856-2.785 3.06.217 1.205 1.168 1.874 2.986 2.046l.569.052c1.33.125 1.773.165 1.856.63.082.464-.496.69-1.009.782-.853.153-1.507-.049-1.691-.52l-2.354.422c.395 1.73 1.975 2.47 4.344 2.045Zm21.872-10.488c.26-.04.526-.03.78.03l-.061-2.127a1.416 1.416 0 0 0-.948-.131c-.581.103-1.091.52-1.531 1.24l-.083.135-.287-.853-2.207.395 1.473 8.22 2.345-.42-.593-3.307c-.333-1.868.058-2.996 1.106-3.182h.006Zm-13.746.352-1.963.351-.446-2.488-2.351.422.446 2.488-1.388.248.398 2.21 1.388-.248 1.082 6.034 2.351-.422-1.083-6.034 1.963-.351-.397-2.21Zm9.228 2.72c-.458-2.552-2.512-4.096-4.891-3.668-2.378.425-3.784 2.522-3.347 4.973.449 2.513 2.565 4.02 5.029 3.577 2.237-.4 3.267-2.198 3.292-3.393l-2.073.144a2.118 2.118 0 0 1-1.589 1.17c-1.339.239-1.999-.412-2.177-1.097l-.015-.08 5.863-1.051-.092-.578v.003Zm-6.04.064-.015-.08c-.077-.739.565-1.402 1.519-1.573 1.085-.196 1.819.327 1.972.947l.015.08-3.491.626Zm-29.777 1.978.091 1.489-.146-.199c-.587-.798-1.706-1.158-2.895-.944-2.296.41-3.69 2.561-3.253 5.01.437 2.448 2.495 3.977 4.787 3.567 1.165-.208 2.113-.954 2.388-1.892l.07-.238.431 1.43 2.21-.394-1.473-8.22-2.21.394v-.003Zm-1.382 6.631c-.407.07-.828.021-1.208-.147a2.115 2.115 0 0 1-.923-.795 2.112 2.112 0 0 1 .052-2.338 2.11 2.11 0 0 1 .957-.752 2.083 2.083 0 0 1 2.274.51c.288.3.477.682.551 1.091a2.04 2.04 0 0 1-1.703 2.43Zm45.126-7.236a.494.494 0 0 0-.067-.187.447.447 0 0 0-.138-.143.503.503 0 0 0-.183-.074.546.546 0 0 0-.199.01l-.495.088.25 1.403.272-.049-.079-.44.159-.027.33.379.321-.058-.388-.42a.47.47 0 0 0 .22-.485l-.003.003Zm-.462.302-.223.04-.076-.43.223-.04a.235.235 0 0 1 .092-.01.18.18 0 0 1 .085.03.21.21 0 0 1 .095.15.236.236 0 0 1 0 .092.236.236 0 0 1-.037.083.175.175 0 0 1-.067.058.231.231 0 0 1-.089.028h-.003Zm-.269-1.29c-.26.046-.498.169-.691.352a1.346 1.346 0 0 0 .902 2.308c.263.006.526-.067.746-.21a1.341 1.341 0 0 0-.957-2.449Zm.425 2.37a1.07 1.07 0 0 1-1.085-.474 1.075 1.075 0 0 1 .021-1.186 1.068 1.068 0 0 1 1.101-.434 1.054 1.054 0 0 1 .816.856c.049.278-.012.562-.174.797-.162.23-.407.389-.682.44h.003Zm-49.873 8.886-2.085-11.632-2.351.422 1.385 7.734-6.927-6.74-2.381.428 2.085 11.631 2.344-.418-1.384-7.731 6.93 6.737 2.384-.428v-.003ZM87.36 55.216c.715 3.993.168 7.202-1.424 9.523-1.465 2.133-3.81 3.515-6.87 4.062l-6.174 1.107-.789-19.55 6.053-1.084c4.325-.774 8.21.388 9.204 5.942Zm-5.524 6.105c.535-1.15.59-2.657.309-4.23-.18-1.007-.529-1.719-1.04-2.153-.58-.498-1.366-.639-2.344-.465l-1.183.211.345 8.872 1.205-.218c1.357-.241 2.225-.984 2.705-2.017h.003ZM94.217 46.394l.788 19.549-5.282.948-.789-19.55 5.283-.947ZM102.522 59.548c.361-.064 1.211-.33 1.098-.966-.107-.602-.976-.758-2.082-.96-1.95-.355-4.637-.844-5.227-4.124-.887-4.949 2.182-8.094 6.187-8.813 1.736-.312 4.289.174 5.79 1.33l-1.804 4.946c-1.079-.749-2.763-1.388-4.017-1.165-.361.065-1.21.33-1.097.966.088.502.902.664 1.959.878 1.978.4 4.821.975 5.408 4.252.902 5.031-2.458 8.373-6.462 9.091-2.171.388-4.366-.19-6.298-1.525l2.168-5.267c1.057.895 3.072 1.59 4.374 1.357h.003ZM123.416 46.388c.517 2.877-.385 5.634-2.308 7.404l3.904 6.777-6.077 1.088-2.797-6.034-.651.116.265 6.487-5.282.947-.789-19.549 6.97-1.25c2.941-.526 6.053.028 6.768 4.01l-.003.004Zm-5.23 1.935c-.174-.97-1.03-1.159-1.752-1.027l-1.302.232.125 3.344 1.376-.247c1.036-.187 1.782-1.033 1.553-2.305v.003ZM130.979 52.147c.192 1.095.795 1.901 2.072 1.672 1.452-.26 1.923-1.528 1.862-3.158l-.462-11.475 5.307-.95.462 11.187c.22 5.793-2.042 9.098-6.9 9.969-4.496.807-6.792-1.266-7.513-5.316a16.605 16.605 0 0 1-.227-2.03l-.437-11.194 5.307-.95.462 11.475c.006.266.027.523.07.767l-.003.003ZM155.318 40.757c.941 5.255-1.434 8.532-5.726 9.302l-1.809.324.241 6.065-5.282.948-.789-19.549 6.97-1.247c2.989-.535 5.707.318 6.395 4.163v-.006Zm-5.194 1.987c-.214-1.189-1.006-1.305-1.874-1.15l-.843.15.152 3.77.942-.169c1.229-.22 1.886-1.137 1.626-2.6h-.003ZM155.37 40.491l-.202-5.016 12.808-2.296.202 5.016-3.763.676.587 14.532-5.282.948-.587-14.532-3.763.675v-.003ZM174.414 32.027l.789 19.548-5.282.948-.789-19.549 5.282-.944v-.003ZM176.646 43.5c-1.232-6.885 2.106-12.562 8.088-13.635 4.317-.773 7.973 1.425 8.893 6.57 1.235 6.884-2.082 12.557-8.086 13.633-4.291.77-7.972-1.424-8.892-6.569h-.003Zm11.781-5.25c-.361-2.017-1.657-3.27-3.466-2.946-2.532.452-3.595 3.411-3.109 6.123.36 2.017 1.657 3.27 3.466 2.946 2.531-.452 3.595-3.411 3.109-6.122ZM200.924 27.28l5.016 9.943a88.415 88.415 0 0 1-.275-3.922l-.257-6.826 5.136-.92.788 19.549-5.499.984-5.233-9.907c.131 1.492.22 2.986.29 4.484l.242 6.267-5.139.92-.789-19.549 5.717-1.024h.003ZM85.022 75.462l.693 17.17-4.64.832-.694-17.17 4.64-.832ZM92.18 74.178l4.409 8.734a76.017 76.017 0 0 1-.242-3.445l-.226-5.998 4.512-.807.694 17.17-4.83.866-4.597-8.7a93.71 93.71 0 0 1 .253 3.937l.211 5.502-4.512.807-.694-17.17 5.02-.899.003.003ZM118.519 74.123c.825 4.613-1.259 7.493-5.032 8.168l-1.589.285.211 5.325-4.641.831-.694-17.17 6.123-1.098c2.626-.47 5.014.281 5.619 3.656l.003.003Zm-4.564 1.746c-.186-1.046-.883-1.147-1.645-1.01l-.742.132.134 3.31.825-.146c1.083-.192 1.657-1 1.428-2.286ZM131.682 71.687c.452 2.525-.339 4.949-2.027 6.502l3.427 5.952-5.337.956-2.458-5.297-.572.104.233 5.698-4.641.831-.694-17.17 6.123-1.098c2.583-.461 5.316.025 5.943 3.522h.003Zm-4.595 1.7c-.152-.85-.904-1.016-1.54-.902l-1.144.204.111 2.938 1.207-.217c.911-.162 1.565-.908 1.363-2.024h.003ZM133.204 77.257c-1.082-6.047 1.85-11.033 7.105-11.974 3.79-.679 7.003 1.25 7.81 5.768 1.082 6.046-1.828 11.03-7.104 11.974-3.773.675-7.004-1.254-7.811-5.769Zm10.348-4.61c-.318-1.773-1.455-2.874-3.045-2.587-2.225.398-3.158 2.996-2.733 5.378.318 1.773 1.455 2.873 3.045 2.586 2.225-.398 3.158-2.996 2.733-5.377ZM163.147 68.281l.324 7.661c-1.85 2.485-3.501 3.66-6.423 4.182-3.708.663-6.82-1.336-7.612-5.753-1.073-5.998 1.703-11.008 6.998-11.956 2.35-.422 4.227.046 6.055 1.947l-2.947 3.687c-.852-.85-1.834-1.201-2.913-1.006-2.329.42-3.026 3.375-2.604 5.729.309 1.724 1.32 2.971 2.928 2.684.508-.092 1.608-.413 1.883-.963l-.039-1.195-2.14.382-.162-4.206 6.652-1.193ZM176.527 63.653c.452 2.525-.34 4.95-2.027 6.502l3.427 5.952-5.338.957-2.457-5.298-.572.101.232 5.698-4.64.832-.694-17.17 6.123-1.098c2.583-.462 5.316.024 5.943 3.521l.003.003Zm-4.595 1.7c-.153-.85-.905-1.015-1.541-.902l-1.143.205.11 2.938 1.208-.217c.911-.162 1.565-.908 1.363-2.024h.003ZM188.103 56.992l.165 4.457-5.38.963.064 1.819 5.084-.91.186 4.453-5.083.91.085 1.939 5.591-1.003.175 4.506-10.21 1.828-.694-17.17 10.02-1.795-.003.003ZM191.301 67.398c.929.786 2.699 1.397 3.842 1.192.318-.058 1.064-.29.963-.85-.095-.528-.856-.666-1.828-.843-1.712-.312-4.075-.74-4.591-3.623-.78-4.347 1.916-7.11 5.435-7.74 1.525-.272 3.766.153 5.083 1.171l-1.583 4.344c-.948-.657-2.427-1.22-3.528-1.021-.318.058-1.064.29-.963.85.08.44.792.584 1.721.77 1.74.351 4.234.856 4.751 3.735.791 4.42-2.158 7.355-5.677 7.985-1.907.343-3.833-.165-5.53-1.339l1.905-4.628v-.003Z"
          />
          <path
            fill="#131313"
            d="M202.804 65.338c.929.785 2.699 1.397 3.842 1.192.318-.058 1.064-.29.963-.85-.095-.529-.856-.666-1.828-.844-1.712-.311-4.075-.74-4.591-3.622-.78-4.347 1.916-7.11 5.435-7.74 1.525-.272 3.766.153 5.087 1.17l-1.584 4.345c-.948-.658-2.427-1.22-3.528-1.022-.318.059-1.063.29-.963.85.08.44.792.584 1.721.77 1.74.352 4.234.856 4.751 3.736.792 4.42-2.158 7.355-5.677 7.985-1.907.342-3.833-.165-5.53-1.34l1.905-4.627-.003-.003Z"
          />
        </g>
        {/* Cat */}
        <mask
          id="a"
          width={206}
          height={168}
          x={0}
          y={62}
          maskUnits="userSpaceOnUse"
          style={{
            maskType: 'luminance',
          }}
        >
          <path
            fill="#fff"
            d="M205.729 62.363H0v146.664h5.634c1.354 11.43 43.362 20.604 94.987 20.604 51.625 0 93.63-9.174 94.987-20.604h10.124V62.363h-.003Z"
          />
        </mask>
        <g mask="url(#a)">
          {/* Arm */}
          <g id="arm">
            <path
              fill="#2259FF"
              d="M144.506 204.983s6.269 12.561 11.258 15.132c4.029 2.078 10.898-16.923 10.898-16.923s-2.782-1.07-1.556-3.207c1.226-2.134 3.381-.388 3.381-.388s1.278-4.081 3.534-3.265c1.498.541 1.131 2.308 1.131 2.308s1.626-1.48 2.84-.89c1.366.667.638 3.109.638 3.109s1.089-1.812 2.559-.953c1.467.859.523 3.056.523 3.056s-10.369 24.22-17.18 29.365c-5.75 4.344-11.5 3.173-18.525-6.618-7.025-9.791-9.614-16.223-9.614-16.223"
            />
            <path
              stroke="#131313"
              strokeLinecap="square"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M144.506 204.983s6.269 12.561 11.258 15.132c4.029 2.078 10.898-16.923 10.898-16.923s-2.782-1.07-1.556-3.207c1.226-2.134 3.381-.388 3.381-.388s1.278-4.081 3.534-3.265c1.498.541 1.131 2.308 1.131 2.308s1.626-1.48 2.84-.89c1.366.667.638 3.109.638 3.109s1.089-1.812 2.559-.953c1.467.859.523 3.056.523 3.056s-10.369 24.22-17.18 29.365c-5.75 4.344-11.5 3.173-18.525-6.618-7.025-9.791-9.614-16.223-9.614-16.223"
            />
          </g>
          {/* Cat */}
          <g id="cat">
            <g>
              <path
                className="headphones"
                fill="#FD81F5"
                d="M145.187 209.66c14.967 0 27.142-13.533 27.142-30.165 0-16.633-12.175-30.166-27.142-30.166-14.966 0-27.142 13.533-27.142 30.166 0 16.632 12.176 30.165 27.142 30.165Z"
              />
              <path
                fill="#2259FF"
                stroke="#131313"
                strokeMiterlimit={10}
                strokeWidth={2}
                d="M159.013 138.978v68.487l-36.691-3.833v-52.854s12.224-14.019 36.691-11.803v.003Z"
              />
              <path
                fill="#2259FF"
                stroke="#131313"
                strokeMiterlimit={10}
                strokeWidth={2}
                d="M40.262 138.431c17.715-1.605 29.007 5.298 33.892 9.232 7.7-3.58 16.315-5.582 25.406-5.582 32.748 0 59.298 25.978 59.298 58.026 0 32.046-26.55 58.026-59.298 58.026-32.749 0-59.298-25.977-59.298-58.026 0-.089 0-.174.003-.26h-.003v-61.416Z"
              />
              <g className="headphones">
                <path
                  fill="#FD81F5"
                  d="M98.135 126.885c-18.27 0-33.745 12.179-38.749 28.845a22.49 22.49 0 0 0-11.54-3.17c-3.09 0-6.034.621-8.718 1.746 5.976-27.075 30.163-47.391 59.007-47.391 23.001 0 42.658 12.282 52.865 31.241-8.639.318-15.02 2.57-20 5-7.352-10.191-19.368-16.271-32.868-16.271h.003Z"
                />
                <path
                  fill="#FD81F5"
                  d="M45.584 209.66c14.99 0 27.142-13.506 27.142-30.165 0-16.66-12.151-30.166-27.142-30.166-14.99 0-27.142 13.506-27.142 30.166 0 16.659 12.152 30.165 27.142 30.165Z"
                />
                <path
                  fill="#131313"
                  d="M27.115 168.496v3.745l-.058.033c-.86.456-1.587 1.183-2.098 2.088-.51.911-.78 1.96-.78 3.039 0 1.079.27 2.13.78 3.038.508.908 1.235 1.633 2.098 2.088l.058.028v.076c0 3.983 1.397 7.801 3.888 10.617 2.491 2.815 5.866 4.398 9.388 4.398 3.521 0 6.896-1.583 9.387-4.398 2.492-2.819 3.889-6.634 3.889-10.617v-.076l.058-.028c.859-.455 1.586-1.183 2.097-2.088.51-.911.78-1.959.78-3.038a6.21 6.21 0 0 0-.78-3.039c-.508-.908-1.235-1.632-2.097-2.088l-.058-.033v-3.742h-1.785c-.297 0-.597.021-.893.064h-.058l-.034-.052c-1.232-1.825-2.818-3.298-4.637-4.316-1.819-1.018-3.821-1.55-5.848-1.55-2.03 0-4.029.529-5.848 1.544-1.819 1.018-3.405 2.494-4.637 4.316l-.037.052h-.058a6.157 6.157 0 0 0-.89-.064h-1.821l-.006.003Zm20.41 1.327-.125.091c-.504.315-.99.667-1.452 1.058l-.049.043-.058-.034a11.177 11.177 0 0 0-5.429-1.525c-1.89.027-3.745.55-5.429 1.525l-.055.034-.055-.043a12.404 12.404 0 0 0-1.449-1.058l-.125-.076.094-.116a9.889 9.889 0 0 1 3.213-2.449 8.876 8.876 0 0 1 3.797-.862c1.302 0 2.592.294 3.797.862a9.961 9.961 0 0 1 3.212 2.449l.107.101h.007Zm-16.785 3.191.132.04c1.705.48 3.295 2.577 3.665 3.09a8.12 8.12 0 0 1 2.705-1.962 7.284 7.284 0 0 1 3.167-.63 7.446 7.446 0 0 1 3.167.63c1.012.44 1.926 1.112 2.705 1.962.373-.513 1.975-2.61 3.666-3.09l.131-.04v9.495c0 2.898-1.018 5.676-2.83 7.728-1.813 2.051-4.274 3.2-6.836 3.2-2.565 0-5.022-1.149-6.835-3.2-1.813-2.052-2.83-4.83-2.83-7.728v-9.495h-.007Z"
                />
              </g>
            </g>
            <path
              fill="#fff"
              d="M132.932 226.971c-10.607 0-19.234-8.63-19.234-19.234 0-10.604 8.63-19.234 19.234-19.234 10.604 0 19.234 8.63 19.234 19.234 0 10.604-8.63 19.234-19.234 19.234Z"
            />
            <path
              fill="#fff"
              d="M103.622 226.971c-10.607 0-19.234-8.63-19.234-19.234 0-10.604 8.63-19.234 19.234-19.234 10.605 0 19.234 8.63 19.234 19.234 0 10.604-8.629 19.234-19.234 19.234Z"
            />
            {/* Eyes */}
            <g id="eyes">
              <path
                fill="#131313"
                d="M109.369 216.336a6.31 6.31 0 0 1-6.303-6.303 6.311 6.311 0 0 1 6.303-6.304 6.311 6.311 0 0 1 6.304 6.304 6.31 6.31 0 0 1-6.304 6.303Z"
              />
              <path
                fill="#131313"
                d="M138.682 216.336a6.31 6.31 0 0 1-6.303-6.303 6.31 6.31 0 0 1 6.303-6.304 6.31 6.31 0 0 1 6.303 6.304 6.31 6.31 0 0 1-6.303 6.303Z"
              />
            </g>
            <path
              fill="#2259FF"
              stroke="#131313"
              strokeMiterlimit={10}
              strokeWidth={2}
              d="M132.932 188.194c10.791 0 19.54 8.749 19.54 19.54 0 .293-.009.587-.022.877h-39.036c-.012-.29-.022-.584-.022-.877 0-10.791 8.749-19.54 19.54-19.54Z"
            />
            <path
              fill="#2259FF"
              stroke="#131313"
              strokeMiterlimit={10}
              strokeWidth={2}
              d="M103.622 188.194c10.791 0 19.54 8.749 19.54 19.54 0 .293-.009.587-.021.877H84.104c-.012-.29-.021-.584-.021-.877 0-10.791 8.749-19.54 19.539-19.54Z"
            />
          </g>
        </g>
      </svg>
    </Box>
  );
};

export default ErrorArtwork;
